import { Injectable } from '@angular/core';
import { filterModelState } from './filter.model';
import { TokenService } from '../service/token.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor(private tokenService: TokenService) { }

  public onSaveLocalsStore(filterState: filterModelState[]): void {
    const userKeyLocals = this.generateUserKeyLocals();

    localStorage.removeItem(userKeyLocals);

    var itemsJson = JSON.stringify(filterState);
    var itemsB64 = btoa(itemsJson);

    localStorage.setItem(userKeyLocals, itemsB64);
  }

  public generateUserKeyLocals(): string {
    var keyUserLocals =
      this.tokenService.getTenant() +
      ':' +
      this.tokenService.getUsername() +
      ':' +
      'IND'; //INDUSTRIAL

    return btoa(keyUserLocals);
  }

  public onLoadLocalsStore(): any {
    var itemsB64 = localStorage.getItem(this.generateUserKeyLocals()) ?? '';

    if (itemsB64 === '') return [];
    else return JSON.parse(atob(itemsB64));
  }

}
